export default "__VITE_ASSET__DrkHi_Zf__"